import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AppAuthService {

  public static readonly defaultPage: string = '/pages/trainings/all/instances';

  private authCodeFlowConfig: AuthConfig = {
    issuer: environment.oauthConfig.stsAuthority,
    redirectUri: environment.authorizationRedirectUrl,
    silentRefreshRedirectUri: environment.authorizationRedirectUrl,
    clientId: environment.oauthConfig.clientId,
    useSilentRefresh: true,
    responseType: 'code',
    scope: environment.oauthConfig.clientScope,
    logoutUrl: '/auth/logout',
    showDebugInformation: true,
  };

  constructor(private oauth: OAuthService,
              private router: Router,
  ) {
    this.oauth.configure(this.authCodeFlowConfig);
  }

  /**
   * Performs the necessary redirects according to the state of authentication
   *
   * @return
   */
  public authenticationRedirectFlow(): Promise<void> {
    this.oauth.setupAutomaticSilentRefresh({}, 'access_token');
    return this.oauth.loadDiscoveryDocumentAndTryLogin().then(() => {
      if (!this.oauth.hasValidIdToken() || !this.oauth.hasValidAccessToken()) {
        localStorage.setItem('entryRequest', window.location.pathname);
        this.oauth.initCodeFlow();
      } else {
        if (localStorage.getItem('entryRequest')) {
          this.router.navigate([localStorage.getItem('entryRequest')]);
          localStorage.removeItem('entryRequest');
        } else {
          this.router.navigateByUrl(AppAuthService.defaultPage);
        }
      }
    });
  }

  /**
   * Return the uuid of the authenticated user find in IdentityClaims
   *
   * @return
   */
  public getAuthenticatedUserUuid(): string {
    const authenticatedUuidPropKey = 'uuid';
    return this.oauth.getIdentityClaims()[authenticatedUuidPropKey];
  }

  /**
   * Return TRUE if the token ID and the Access Token are both valid. FALSE otherwise
   *
   * @return
   */
  public isAuthenticated(): boolean {
    return this.oauth.hasValidAccessToken();
  }
}
